import React, { useState, useEffect } from "react";

const isLocalDev = process.env.NODE_ENV === "development";
const shouldHide = !!process.env.REACT_APP_HIDE_QA;

const QA: React.FC = () => {
  const [component, setComponent] = useState<React.ReactElement | null>(null);

  useEffect(() => {
    if (!shouldHide || isLocalDev) {
      import("@hackthenorth/quai").then((module) => {
        const Quai = module.default;
        setComponent(
          <span style={{ zIndex: 100, position: "absolute" }}>
            <Quai projectEpicKey="FE-1948" />
          </span>
        );
      });
    }
  }, []);

  return component;
};

export default QA;
